<ng-container>
    <h2 mat-dialog-title class="dialog-header">
        <span class="dialog-title title-large">{{ 'customers.ui.selezionaDestiniDiConsegna' | transloco }}</span>

        <button
            mat-icon-button
            type="button"
            [attr.aria-label]="'customers.ui.chiudi' | transloco"
            class="close-button"
            (click)="onClose()"
        >
            <i class="fa-regular fa-xmark"></i>
        </button>
    </h2>

    <mat-dialog-content class="content">
        <span class="headline-small-emphasized">{{ 'customers.ui.destiniDiConsegna' | transloco }}</span>

        <mat-form-field appearance="outline" class="searchbar">
            <input matInput [placeholder]="'customers.ui.cercaDestinoDiConsegna' | transloco">
            <i matSuffix class="fa-regular fa-magnifying-glass icon-prefix"></i>
        </mat-form-field>

        <div class="destinations-list">
            @for (destination of destinations; track $index) {
                <mat-card
                    appearance="outlined"
                    class="destination-card"
                    [class.destination-card-selected]="selectedIndex === $index"
                    (click)="onSelectDestination($index)"
                >
                    <mat-card-content class="destination-card-content">
                        <div class="destination-card-layout">
                            <div class="destination-card-fields">
                                @for (field of destinationFields; track field.key) {
                                    <div class="destination-card-field">
                                        <span class="body-small">{{ field.label }}</span>
                                        <span class="body-small-emphasized">{{ field.key === 'missing' ? '-' : (destination[field.key] || '-') }}</span>
                                    </div>
                                }
                            </div>

                            <div class="destination-card-action">
                                <button
                                    matIconButton
                                    type="button"
                                    [attr.aria-label]="'customers.ui.informazioniIndirizzo' | transloco"
                                    (click)="openAddressDetailsDialog($event, destination)"
                                >
                                    <i class="fa-regular fa-circle-info"></i>
                                </button>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            }
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="buttons-container">
        <button matButton type="button" (click)="onReset()">{{ 'customers.ui.cancella' | transloco }}</button>
        <button matButton="filled" type="button" (click)="onApply()">{{ 'customers.ui.applica' | transloco }}</button>
    </mat-dialog-actions>
</ng-container>
